/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        avatarGroup: {
            avatar: {
                borderWidth: {
                    value: "1px",
                    type: "dimension",
                },
                marginLeft: {
                    value: "-4px",
                    type: "dimension",
                },
            },
            additionalAvatar: {
                backgroundColor: {
                    value: "#dadada",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
